import { pathOr, min } from "ramda";

// Jaar, 0 KTL, 1 KTL, 2 KTL, 3 KTL, 3+ KTL
const data = {
  1986: [49578.7, 49578.7, 49578.7, 49578.7, 49578.7],
  1987: [49578.7, 49578.7, 49578.7, 49578.7, 49578.7],
  1988: [49578.7, 49578.7, 49578.7, 49578.7, 49578.7],
  1989: [49578.7, 52057.64, 54536.58, 59494.45, 64452.32],
  1990: [51115.64, 53668.95, 56222.25, 61353.65, 66460.25],
  1991: [52875.69, 55528.15, 58180.61, 63460.74, 68740.87],
  1992: [54536.58, 57263.4, 59990.23, 65443.89, 70872.76],
  1993: [54536.58, 57263.4, 59990.23, 65443.89, 70872.76],
  1994: [54536.58, 57263.4, 59990.23, 65443.89, 70872.76],
  1995: [54536.58, 57263.4, 59990.23, 65443.89, 70872.76],
  1996: [54536.58, 57263.4, 59990.23, 65443.89, 70872.76],
  1997: [54536.58, 57263.4, 59990.23, 65443.89, 70872.76],
  1998: [54536.58, 57263.4, 59990.23, 65443.89, 70872.76],
  1999: [55057.15, 57808.77, 60560.39, 66063.62, 71566.86],
  2000: [55652.1, 58453.29, 61229.7, 66782.52, 72360.12],
  2001: [57570.0, 60440.0, 63320.0, 69080.0, 74830.0],
  2002: [58990.0, 61930.0, 64880.0, 70780.0, 76680.0],
  2003: [59960.0, 62950.0, 65950.0, 71950.0, 77940.0],
  2004: [60910.0, 63960.0, 67000.0, 73090.0, 79180.0],
} as { [jaarLening: number]: number[] };

export const getBouwsparenLimit = (jaarLening: number, kinderenTenLasten: number = 0) => {
  return pathOr(0, [jaarLening, min(kinderenTenLasten, 4)], data);
};
